import Http from "../http";
import createAccountApis from "./account";
import createWalletApis from "./wallet";
import createMarketApis from "./market";
import createFoxoneApis from "./foxone";
import createSurveyApis from "./survey";
import createDefiApis from "./defi";
import createHfoxApis from "./hfox";
import { ApiUseOptions } from "../index";
import utils from "../utils";

export const ERRORS = {
  FOXONE_MIGRATE_REQUIRE: 101007,
  MIXIN_BIND_REQUIRE: 110999,
  MIXIN_LOGIN_REQUIER: 101009
};

function genResStructInterceptor(options: ApiUseOptions) {
  return [
    function(res) {
      const reqId = res?.headers?.["x-request-id"];
      const resId = res?.config?.headers?.["x-request-id"];
      if (reqId && resId && reqId !== resId) {
        return Promise.reject(
          new Error(
            `X-Request-Id Not Match: request: ${res.headers["x-request-id"]}; response: ${res.config.headers["x-request-id"]}`
          )
        );
      }
      return res.data;
    },
    function(error) {
      if (error.response && error.response.data) {
        const status = error.response.status;
        if (status === 401) {
          options.store.dispatch("auth/logout");
        }
        const { code, msg: message } = error.response.data;
        if (code === ERRORS.FOXONE_MIGRATE_REQUIRE) {
          options.store.commit("app/SET_NEED_FOXONE_MIGRATE", true);
        }
        if (code === ERRORS.MIXIN_BIND_REQUIRE) {
          options.store.dispatch("removeMixinBindData");
        }
        if (code === ERRORS.MIXIN_LOGIN_REQUIER) {
          options.store.dispatch("removeMixinBindData");
          options.store.commit("app/SET_MIXIN_LOGIN_OUTDATE", true);
        }
        return Promise.reject({ code, message, status: error.response.status });
      } else {
        return Promise.reject(error);
      }
    }
  ];
}

function genAuthInterceptor(options: ApiUseOptions) {
  return [
    function(config) {
      const token = options.store.getters["auth/getToken"];
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  ];
}

export default function(options: ApiUseOptions) {
  const configs = {
    baseURL: options.configs.FUSION_API_HOST,
    headers: {
      "Accept-Language": utils.getLocale()
    }
  };
  const http = new Http(
    configs,
    [genAuthInterceptor(options)],
    [genResStructInterceptor(options)]
  );
  return {
    wallet: createWalletApis(http),
    account: createAccountApis(http),
    market: createMarketApis(http),
    defi: createDefiApis(http),
    foxone: createFoxoneApis(http),
    survey: createSurveyApis(http),
    hfox: createHfoxApis(http)
  };
}
